import { Icon } from '@chakra-ui/react';

// SFDownload
export default function SFSquareArrowDown(props) {
  return (
    <Icon
      width='14px'
      height='18px'
      viewBox='0 0 14 18'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M6.99219 12.4609C6.83594 12.4609 6.70312 12.4141 6.53906 12.2578L3.89844 9.70312C3.78125 9.58594 3.71875 9.46094 3.71875 9.29688C3.71875 8.97656 3.95312 8.75 4.28125 8.75C4.42969 8.75 4.60156 8.8125 4.71094 8.9375L5.89062 10.1953L6.42188 10.75L6.375 9.57812V1.34375C6.375 1.01562 6.65625 0.734375 6.99219 0.734375C7.32812 0.734375 7.61719 1.01562 7.61719 1.34375V9.57812L7.57031 10.75L9.28125 8.9375C9.39062 8.8125 9.54688 8.75 9.70312 8.75C10.0234 8.75 10.2734 8.97656 10.2734 9.29688C10.2734 9.46094 10.2031 9.58594 10.0859 9.70312L7.44531 12.2578C7.28906 12.4141 7.15625 12.4609 6.99219 12.4609ZM2.51562 17.6016C0.882812 17.6016 0.0625 16.7891 0.0625 15.1797V7.38281C0.0625 5.77344 0.882812 4.96094 2.51562 4.96094H4.86719V6.21875H2.53125C1.75 6.21875 1.32031 6.64062 1.32031 7.45312V15.1094C1.32031 15.9219 1.75 16.3438 2.53125 16.3438H11.4531C12.2266 16.3438 12.6719 15.9219 12.6719 15.1094V7.45312C12.6719 6.64062 12.2266 6.21875 11.4531 6.21875H9.125V4.96094H11.4766C13.1094 4.96094 13.9297 5.77344 13.9297 7.38281V15.1797C13.9297 16.7891 13.1094 17.6016 11.4766 17.6016H2.51562Z' />
    </Icon>
  );
}
